import Mixin from "../../mixin.js";
import Funnel from "../../services/funnel-service.js";

const template = `
    <a v-show="fs.display(input)"
        :disabled="input.loading || disabledBtn.indexOf('disabled') >= 0"
        :id="iuid"
        :class="computedClasses"
        @click.prevent="setLoading(input, $event), exec($event, input, {skipUpdate:true})"
        @keydown.space.prevent="emulateClick(input, $event)"
        @keydown.enter.prevent="emulateClick(input, $event)"
        :data-uid="iuid"
        tabindex="0"
        role="button"
        :aria-disabled="input.loading || disabledBtn.indexOf('disabled') >= 0"
        :aria-label="input.label"
    >
        <span>
            <img alt="plus" class="iconic iconic-sm icon" src="/static/images/iconic/plus.svg">
            {{ input.label }}
        </span>
    </a>
`;

export default {
    name: 'b-center-button-card',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    computed: {
        ...Vuex.mapGetters([
            'funnel',
            'active_page',
            'disable_next'
        ]),
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        validationRules() {
            // v-bind="validationRules"
            return this.input.validation
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        computedClasses: function () {
            var classes = ["card s12 clm text-center center-button-card"]
            if (this.input.loading) {
                classes.push("loading-button disabled")
            }
            classes.push(this.disabledBtn)
            return classes
        },
        disabledBtn: function(){
            const status = [];
            let is_disabled = false;

            if (this.disable_next) {
                is_disabled = true;
            }

            if (!is_disabled) {
                Object.keys(this.funnel.elements).map((el,i) => {
                    if (!this.funnel.elements[el]) {
                        return;
                    }

                    if (this.funnel.elements[el].loading) {
                        is_disabled = true;
                    }
                });
            }

            if (is_disabled) {
                status.push('disabled');
            }

            return status.join(' ');
        }
    },
    mounted: function () {
        this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'loading', val: false });
    },
    methods: {
        emulateClick: function(input, e){
            console.log(e.target.dataset.uid);
            var element = document.querySelector("[data-uid='"+e.target.dataset.uid+"']")
            element.click();
        },
        setLoading: function (input, e) {
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: input.uid, key: 'loading', val: true });
        }
    }
};